export const PAGINATOR_CONSTANTS = {
  DEFAULT_ROWS: 100,
  ROWS_PER_PAGE: [25, 50, 100, 500],
};
